export default "__VITE_ASSET__CGFGnKbq__"